import api, { ApiResponse } from './api';

export interface DashboardStats {
  totalEmployees: number;
  activeEmployees: number;
  presentToday: number;
  absentToday: number;
  lateToday: number;
  onLeave: number;
  // 2026-08-15: Donemde izin kullanan toplam kisi (calismis olsa bile)
  onLeaveTotal?: number;
  // 2026-08-15: Erken cikan personel sayisi (gec gelenlerle ayni kartta)
  earlyLeaveToday?: number;
  pendingLeaves: number;
  totalDevices: number;
  onlineDevices: number;
}

export interface AttendanceTrendItem {
  date: string;
  dayName?: string;
  // 2026-08-15 FIX: Backend presentCount/absentCount/lateCount donuyordu; burada
  // present/absent/late okunuyordu -> hepsi undefined kalip grafik devamsizlari
  // ve gec gelenleri HIC gostermiyordu. Iki isim de kabul edilir (geriye donuk).
  presentCount?: number;
  absentCount?: number;
  lateCount?: number;
  // 2026-08-15: Izinli personel grafikte ayri seri
  leaveCount?: number;
  present?: number;
  absent?: number;
  late?: number;
  attendanceRate?: number;
}

export interface DepartmentDistribution {
  departmentId: number;
  departmentName: string;
  employeeCount: number;
  presentCount: number;
  absentCount: number;
}

export interface RecentActivity {
  id: number;
  type: string;
  message: string;
  timestamp: string;
  employeeName?: string;
}

export interface EmployeeListItem {
  id: number;
  fullName: string;
  employeeCode?: string;
  departmentName?: string;
}

export interface LateEmployeeItem {
  id: number;
  fullName: string;
  employeeCode?: string;
  departmentName?: string;
  entryTime: string;
  lateMinutes: number;
}

export interface EmployeeStatsSummary {
  weeklyLateCount: number;
  weeklyAbsentCount: number;
  monthlyLateCount: number;
  monthlyAbsentCount: number;
  topLateEmployees: EmployeeStatItem[];
  topAbsentEmployees: EmployeeStatItem[];
}

export interface EmployeeStatItem {
  id: number;
  fullName: string;
  departmentName?: string;
  lateCount: number;
  absentCount: number;
  weeklyLateCount: number;
  weeklyAbsentCount: number;
}

export interface EmployeeDetailStats {
  employeeId: number;
  fullName: string;
  employeeCode?: string;
  departmentName?: string;
  positionName?: string;
  weeklyLateCount: number;
  weeklyAbsentCount: number;
  weeklyPresentCount: number;
  weeklyLateMinutes: number;
  monthlyLateCount: number;
  monthlyAbsentCount: number;
  monthlyPresentCount: number;
  monthlyLateMinutes: number;
  weeklyWorkDays: number;
  monthlyWorkDays: number;
  recentEntries: RecentEntry[];
  absentDates: AbsentDate[];
}

export interface AbsentDate {
  date: string;
  dayName: string;
  status: 'Absent' | 'OnLeave' | 'Holiday';
  leaveType?: string;
}

export interface RecentEntry {
  date: string;
  checkIn: string;
  checkOut?: string;
  lateMinutes: number;
  workedMinutes: number;
}

const dashboardService = {
  getStats: async (
    period: string = 'daily',
    filtreBas?: string,
    filtreBit?: string
  ): Promise<ApiResponse<DashboardStats>> => {
    // 2026-08-15 FIX: Donem (gunluk/haftalik/aylik) backend'e HIC gonderilmiyordu;
    // bu yuzden Haftalik/Aylik secilince rakamlar degismiyordu.
    // Ayrica ozel tarih araligi destegi eklendi (filtreBas / filtreBit).
    const params = new URLSearchParams({ period });
    if (filtreBas) params.append('filtreBas', filtreBas);
    if (filtreBit) params.append('filtreBit', filtreBit);
    return api.get(`/dashboard/stats?${params}`);
  },

  getAttendanceTrend: async (days: number = 7): Promise<ApiResponse<AttendanceTrendItem[]>> => {
    return api.get(`/dashboard/attendance-trend?days=${days}`);
  },

  getDepartmentDistribution: async (): Promise<ApiResponse<DepartmentDistribution[]>> => {
    return api.get('/dashboard/department-distribution');
  },

  getRecentActivity: async (limit: number = 10): Promise<ApiResponse<RecentActivity[]>> => {
    return api.get(`/dashboard/recent-activity?limit=${limit}`);
  },

  getPresentEmployees: async (): Promise<ApiResponse<EmployeeListItem[]>> => {
    return api.get('/dashboard/present-employees');
  },

  getAbsentEmployees: async (): Promise<ApiResponse<EmployeeListItem[]>> => {
    return api.get('/dashboard/absent-employees');
  },

  getLateEmployees: async (): Promise<ApiResponse<LateEmployeeItem[]>> => {
    return api.get('/dashboard/late-employees');
  },

  getEmployeeStatsSummary: async (): Promise<ApiResponse<EmployeeStatsSummary>> => {
    return api.get('/dashboard/employee-stats-summary');
  },

  getEmployeeDetailStats: async (employeeId: number): Promise<ApiResponse<EmployeeDetailStats>> => {
    return api.get(`/dashboard/employee-stats/${employeeId}`);
  },
};

export default dashboardService;
